import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import { ManagerContextProvider } from '../manager/components/context';
import Notification from './notification/notification';
import Integration from './integration/integration';
import AdditionalService from './additionalService';
import ModuleDisplay from './module_display/moduleDisplay';
import PayementAndInvoicing from './payementAndInvoicing';
import PageError from '../error/pageError';
import AuthRoute from '../../utils/authRoute';

export default function TicketOptions({ organization, event, path }) {
    return (
        <ManagerContextProvider>
            <Switch>
                <Route path={`${path}/notification`} render={routeProps => <Notification organization={organization} event={event} />} />
                <Route exact path={`${path}/payementinvoicing`} render={basenameProps => <PayementAndInvoicing organization={organization} event={event} />} />
                <Route exact path={`${path}/moduledisplay`} render={basenameProps => <ModuleDisplay event={event} organization={organization} />} />
                <Route exact path={`${path}/additionalservice`} render={basenameProps => <AdditionalService organization={organization} event={event} />} />
                <AuthRoute
                    exact
                    allow={['PyvarCapacity.ANALYTICS']}
                    path={`${path}/integration`}
                    render={basenameProps => <Integration organization={organization} event={event} />}
                />
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/E${event.id}/dashboard`} />} />
            </Switch>
        </ManagerContextProvider>
    );
}

TicketOptions.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
